import { EventPeriodEnum } from '../../../utils/api';

export type OvertimeUiMode = 'play' | 'penalty_shootout';

/** Short labels so the trailing clock text keeps similar width (less quarter-button shifting). */
export function shortPeriodClockLabel(
    period: EventPeriodEnum,
    overtimeMode: OvertimeUiMode = 'play'
): string {
    switch (period) {
        case EventPeriodEnum.First_Period:
            return '1st Period';
        case EventPeriodEnum.Second_Period:
            return '2nd Period';
        case EventPeriodEnum.Third_Period:
            return '3rd Period';
        case EventPeriodEnum.Fourth_Period:
            return '4th Period';
        case EventPeriodEnum.Overtime:
            return overtimeMode === 'penalty_shootout' ? 'Overtime (PSO)' : 'Overtime';
        default:
            return '';
    }
}

export function formatMatchSecondsAsClock(totalSeconds: number): string {
    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds - m * 60;
    return `${m < 10 ? `0${m}` : m}:${s < 10 ? `0${s}` : s}`;
}
